import { Container, Sprite } from '@pixi/react';
import { isMobile } from '../../../helpers/isMobile';
import { getGameImages } from '../../../helpers/getGameImages';

export const GameBoard = () => {
    const { gameBoard } = getGameImages();

    const containerConfig = {
        x: isMobile() ? 0 : 241,
        y: isMobile() ? 245 : 121,
    }


    return (
        <Container {...containerConfig} name='GameBoardContainer'>
            <Sprite anchor={0} texture={gameBoard} />
        </Container>
    );
};
